import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

// ─── List ───
export interface CustomerListRow {
  partnerId: string;
  regNumber: string | null;
  businessName: string | null;
  types: string[];
  isBuyer: boolean;
  isSupplier: boolean;
  adminName: string | null;
  completenessPercent: number;
}

export interface CustomerListResult {
  rows: CustomerListRow[];
  total: number;
  page: number;
  limit: number;
}

export interface ListCustomersParams {
  search?: string;
  page?: number;
  limit?: number;
}

// ─── Detail ───
export interface CustomerContact {
  id: string;
  name: string | null;
  position: string | null;
  email: string | null;
  phone: string | null;
  isPrimary: boolean | null;
}

export interface CustomerBusiness {
  id: string;
  type: string;
  profileName: string | null;
  profileNameEng: string | null;
  businessStatus: string | null;
  businessSectorId: string | null;
  sectorName: string | null;
}

export interface CustomerBankAccount {
  id: string;
  bankName: string | null;
  number: string | null;
  name: string | null;
  currency: string | null;
  isDefault: boolean | null;
  isVerified: boolean | null;
}

export interface CompletenessSection {
  key: string;
  label: string;
  filled: number;
  total: number;
}

export interface Completeness {
  overall: { filled: number; total: number; percent: number };
  sections: CompletenessSection[];
}

export interface CustomerDetail {
  partner: {
    partnerId: string;
    regNumber: string | null;
    businessName: string | null;
    businessNameEng: string | null;
    legalEntityType: string | null;
    isVatPayer: boolean;
    partnerStatus: string | null;
    registerStatus: string | null;
    web: string | null;
    email: string | null;
    phone: string | null;
    sectorName: string | null;
  };
  address: {
    country: string | null;
    province: string | null;
    district: string | null;
    businessAddress: string | null;
    locationLat: number | null;
    locationLng: number | null;
  };
  contact: {
    email: string | null;
    phone: string | null;
    primaryContact: CustomerContact | null;
    contacts: CustomerContact[];
  };
  businessProfile: {
    buyerBusinessName: string | null;
    supplierBusinessName: string | null;
    businessStatus: string | null;
    businesses: CustomerBusiness[];
  };
  bankAccounts: CustomerBankAccount[];
  admin: {
    name: string | null;
    familyName: string | null;
    registerNo: string | null;
    username: string | null;
    email: string | null;
    email2: string | null;
    phone: string | null;
    phone2: string | null;
    avatar: string | null;
    userStatus: string | null;
    isAdmin: boolean;
    isEmailVerified: boolean;
    isPhoneVerified: boolean;
    isDanVerified: boolean;
    createdAt: string | null;
  } | null;
  completeness: Completeness;
}

export const listCustomers = (params?: ListCustomersParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get("/bil/my/customers", params as any) as Promise<CustomerListResult>;

export const getCustomer = (partnerId: string) =>
  httpRequest.get(`/bil/my/customers/${partnerId}`) as Promise<CustomerDetail>;
